import {MILEAGE_RANGE} from '../consts/MILEAGE_RANGE';
import {POWER_RANGE} from '../consts/POWER_RANGE';
import {YEAR_RANGE} from '../consts/YEAR_RANGE';
import {VehicleData} from '../types/VehicleData';
import {getYearFromDateString} from './getYearFromDateString';

const SORT_BY = 'price';
const DIRECTION = 'asc';
const LIMIT = 3;

export const getFilters = (vehicleData: VehicleData) => {
  const yearDateString = vehicleData?.firstRegistrationOn ?? vehicleData?.manufacturedOn;
  const year = yearDateString ? getYearFromDateString(yearDateString) : undefined;
  const power = vehicleData?.power;
  const relaxedFilters = {
    model: vehicleData?.modelFamily ? [vehicleData.modelFamily] : undefined,
    'registration-date-from': year ? Number(year) : undefined,
    'registration-date-to': year ? Number(year) + YEAR_RANGE : undefined,
    sort: SORT_BY,
    direction: DIRECTION,
    limit: LIMIT,
  };

  const strictFilters = {
    ...relaxedFilters,
    transmission: vehicleData?.transmission ? [vehicleData.transmission] : undefined,
    'fuel-type': vehicleData?.fuelType ? [vehicleData.fuelType] : undefined,
    'power-from': power ? Math.max(0, Number(power)) : undefined,
    'power-to': power ? Number(power) + POWER_RANGE : undefined,
    'power-unit': power ? ('kw' as const) : undefined,
    'mileage-to': vehicleData?.mileage ? Number(vehicleData.mileage) + MILEAGE_RANGE : undefined,
  };
  return {relaxedFilters, strictFilters};
};
